// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/categorize_project_images.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/categorize_project_images.proto.
 */
export const file_vision_assets_v1_categorize_project_images: GenFile = /*@__PURE__*/
  fileDesc("CjB2aXNpb24vYXNzZXRzL3YxL2NhdGVnb3JpemVfcHJvamVjdF9pbWFnZXMucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIqEBCh5DYXRlZ29yaXplUHJvamVjdEltYWdlc1JlcXVlc3QSTgoGcGFyYW1zGAEgASgLMj4ucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuQ2F0ZWdvcml6ZVByb2plY3RJbWFnZXNSZXF1ZXN0LlBhcmFtcxovCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIRCglhc3NldF9pZHMYAiADKAkikgEKH0NhdGVnb3JpemVQcm9qZWN0SW1hZ2VzUmVzcG9uc2USTwoGcmVzdWx0GAEgASgLMj8ucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuQ2F0ZWdvcml6ZVByb2plY3RJbWFnZXNSZXNwb25zZS5SZXN1bHQaHgoGUmVzdWx0EhQKDHF1ZXVlZF9jb3VudBgBIAEoBWIGcHJvdG8z");

/**
 * @generated from message protos.vision.assets.v1.CategorizeProjectImagesRequest
 */
export type CategorizeProjectImagesRequest = Message<"protos.vision.assets.v1.CategorizeProjectImagesRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.CategorizeProjectImagesRequest.Params params = 1;
   */
  params?: CategorizeProjectImagesRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.CategorizeProjectImagesRequest.
 * Use `create(CategorizeProjectImagesRequestSchema)` to create a new message.
 */
export const CategorizeProjectImagesRequestSchema: GenMessage<CategorizeProjectImagesRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_categorize_project_images, 0);

/**
 * @generated from message protos.vision.assets.v1.CategorizeProjectImagesRequest.Params
 */
export type CategorizeProjectImagesRequest_Params = Message<"protos.vision.assets.v1.CategorizeProjectImagesRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated string asset_ids = 2;
   */
  assetIds: string[];
};

/**
 * Describes the message protos.vision.assets.v1.CategorizeProjectImagesRequest.Params.
 * Use `create(CategorizeProjectImagesRequest_ParamsSchema)` to create a new message.
 */
export const CategorizeProjectImagesRequest_ParamsSchema: GenMessage<CategorizeProjectImagesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_categorize_project_images, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.CategorizeProjectImagesResponse
 */
export type CategorizeProjectImagesResponse = Message<"protos.vision.assets.v1.CategorizeProjectImagesResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.CategorizeProjectImagesResponse.Result result = 1;
   */
  result?: CategorizeProjectImagesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.CategorizeProjectImagesResponse.
 * Use `create(CategorizeProjectImagesResponseSchema)` to create a new message.
 */
export const CategorizeProjectImagesResponseSchema: GenMessage<CategorizeProjectImagesResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_categorize_project_images, 1);

/**
 * @generated from message protos.vision.assets.v1.CategorizeProjectImagesResponse.Result
 */
export type CategorizeProjectImagesResponse_Result = Message<"protos.vision.assets.v1.CategorizeProjectImagesResponse.Result"> & {
  /**
   * @generated from field: int32 queued_count = 1;
   */
  queuedCount: number;
};

/**
 * Describes the message protos.vision.assets.v1.CategorizeProjectImagesResponse.Result.
 * Use `create(CategorizeProjectImagesResponse_ResultSchema)` to create a new message.
 */
export const CategorizeProjectImagesResponse_ResultSchema: GenMessage<CategorizeProjectImagesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_categorize_project_images, 1, 0);

